import { AmplifyFilter } from "@utils/Api";

export const cacheKeyAllByTenant = (modelName: string, tenantId: string, filter: AmplifyFilter = {}): string => {
    const filters = btoa(JSON.stringify(filter));

    return `allByTenant:${modelName}:${tenantId}-f-${filters}`;
}